import React, { useState } from 'react';

const SLIDES = [
  {
    title: '많은 대화가 오가는 화상회의,\n중요 내용 놓칠까 걱정하지 마세요!',
    img: 'https://static.wehago.com/imgs/rtc/dialog_oneai2.png',
    imgHeight: 260,
  },
  {
    title: '많은 대화가 오가는 화상회의,\n중요 내용 놓칠까 걱정하지 마세요!',
    img: 'https://static.wehago.com/imgs/rtc/dialog_oneai.png',
    imgHeight: 254,
  },
  {
    title: '회의 중간에 참여해도\n이전 회의 내용을 분석하고 요약해서 알려줘요!',
    img: 'https://static.wehago.com/imgs/rtc/dialog_oneai_2.png',
    imgHeight: 265,
  },
  {
    title: '회의가 끝나면 회의록을 작성하고\n담당자 별로 할 일을 정리해줘요!',
    img: 'https://static.wehago.com/imgs/rtc/dialog_oneai_3.png',
    imgHeight: 271,
  },
];

interface OneAiPromoDialogProps {
  onClose: () => void;
}

const OneAiPromoDialog: React.FC<OneAiPromoDialogProps> = ({ onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slide = SLIDES[currentIndex];

  const handleLearnMore = () => {
    window.open('https://www.wehago.com/landing/ko/oneai/', '_blank', 'noreferrer');
  };

  return (
    <div className="LUX_basic_dialog">
      <div className="dimmed" onClick={onClose} />
      <div className="dialog_wrap_tbl">
        <div className="dialog_wrap_tbl">
          <div className="dialog_wrap_tblcel">
            <div className="dialog_wrap" style={{ border: 0, borderRadius: 20, padding: 0 }}>
              <div className="dialog_content rtc_dialog rtc_new3_dialog roundstyle" style={{ width: 440 }}>
                <div className="rtcDialog_oneaiBox">
                  <button type="button" className="btn_exit" onClick={onClose}>
                    <span className="blind">팝업 닫기</span>
                  </button>
                  <h2 className="rtcDialog_oneaiBox__title">
                    {slide.title.split('\n').map((line, i) => (
                      <React.Fragment key={i}>{line}{i < slide.title.split('\n').length - 1 && <br />}</React.Fragment>
                    ))}
                  </h2>
                  <div className="rtcDialog_oneaiBox__imgBox" style={{ height: slide.imgHeight }}>
                    <img src={slide.img} style={{ height: slide.imgHeight }} alt="ONE AI 소개" />
                  </div>
                  <div className="rtcDialog_oneaiBox__dots">
                    {SLIDES.map((_, i) => (
                      <button
                        key={i}
                        type="button"
                        className={`rtcDialog_oneaiBox__dot${i === currentIndex ? ' active' : ''}`}
                        onClick={() => setCurrentIndex(i)}
                      />
                    ))}
                  </div>
                  <div className="rtcDialog_oneaiBox__footer">
                    <button
                      type="button"
                      className="rtcDialog_oneaiBox__footerBtn"
                      onClick={handleLearnMore}
                    >
                      ONE AI 자세히 알아보기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneAiPromoDialog;
